import { useState } from 'react'
import { Image } from '@/atoms/Image'
import { ParagraphMD } from '@/atoms/Text'
import { GTitleLG, GTitleXXL } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

const faqs = [
  {
    question: `How can I use my pre-order tickets?`,
    answer: `Young Washington will be in theaters July 3rd, 2026. Traditionally, showtimes are not available until 90-days before the theatrical release date. When this time gets closer, we will notify you via email and a link to redeem your pre-order tickets. When this is available, you will be able to select your preferred theater and showtime.
`,
  },
  {
    question: `Why should I pre-order tickets so early?`,
    answer: `Pre-ordering tickets early helps us secure more theaters, reach more audiences, and demonstrates the demand for stories that celebrate America. Your early support directly contributes to the film's success and helps us make Young Washington the #1 movie on America's 250th birthday.`,
  },
  {
    question: `When does Young Washington come out in theaters?`,
    answer: `Young Washington will be released in theaters the day before Independence Day, July 3rd, 2026 - America's 250th birthday. This date was specifically chosen to celebrate our nation's history and the story of our first hero.`,
  },
  {
    question: `Can I gift my pre-order tickets to someone else?`,
    answer: `Yes! Pre-order tickets make great gifts for history buffs, movie lovers, and anyone who appreciates America's founding story. You can purchase tickets and share the redemption details with your gift recipient when showtimes become available.`,
  },
  {
    question: `What if I lose my promo codes for my pre-order tickets?`,
    answer: `Don't worry! All pre-order purchases are linked to your email address. If you lose your promo codes, simply contact our customer support team with your email address and order confirmation, and we'll help you recover your tickets.`,
  },
]

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <section className="relative bg-[#00142C] py-16">
      <div className="container relative mx-auto max-w-4xl px-4 text-white">
        <GTitleXXL className="mb-2 hidden uppercase md:block">Frequently Asked Questions</GTitleXXL>
        <GTitleLG className="mb-2 uppercase md:hidden">Frequently Asked Questions</GTitleLG>
        <ParagraphMD className="mb-8 !font-roboto ">
          Browse this collection of frequently asked questions to help answer anything that you might be wondering.
        </ParagraphMD>

        <div className="space-y-0">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index
            return (
              <div key={index}>
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center gap-4 pb-2 pt-6 text-left transition"
                >
                  <div className="relative h-6 w-6 shrink-0">
                    <div
                      className="absolute inset-0 transition-all duration-500 ease-in-out"
                      style={{
                        opacity: isOpen ? 0 : 1,
                        transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                      }}
                    >
                      <Image
                        src="v1759419811/theatrical/young%20washington/icon-plus.webp"
                        alt="Expand"
                        width={24}
                        height={24}
                      />
                    </div>
                    <div
                      className="absolute inset-0 transition-opacity duration-200 ease-in-out"
                      style={{
                        opacity: isOpen ? 1 : 0,
                      }}
                    >
                      <Image
                        src="v1759419811/theatrical/young%20washington/icon-minus.webp"
                        alt="Collapse"
                        width={24}
                        height={24}
                      />
                    </div>
                  </div>
                  <span className="!font-roboto text-lg font-bold  md:text-xl">{faq.question}</span>
                </button>
                <div
                  className="overflow-hidden transition-all duration-500 ease-in-out"
                  style={{
                    maxHeight: isOpen ? '500px' : '0px',
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <div className="pb-6 pl-10">
                    <ParagraphMD className="!font-roboto ">{faq.answer}</ParagraphMD>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
